export type SocialErrorCode =
  | "SOCIAL_SYNC_FAILED"
  | "SOCIAL_SYNC_NO_WORKER"
  | "SOCIAL_FETCH_FAILED"

export class SocialError extends Error {
  readonly code: SocialErrorCode

  constructor(code: SocialErrorCode, message?: string) {
    super(message ?? code)
    this.code = code
    this.name = "SocialError"
  }
}

export function getSocialErrorCode(error: unknown): SocialErrorCode | null {
  return error instanceof SocialError ? error.code : null
}
